import React from 'react';
import { useLocale } from '../i18n/LocaleContext';

const Fallback = ({ onReload }) => {
  const { t } = useLocale();

  return (
    <div
      role="alert"
      className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-6 py-24 text-center"
    >
      <h2 className="font-bricolage font-extrabold text-[#262624] text-2xl sm:text-3xl">
        {t('common.errorTitle')}
      </h2>
      <p className="font-space text-[#262624]/75 text-base max-w-[420px] leading-[1.5]">
        {t('common.errorBody')}
      </p>
      <button
        type="button"
        onClick={onReload}
        className="mt-2 inline-flex items-center rounded-full bg-[#f97b22] hover:bg-[#fe9043] text-[#262624] px-6 py-3 font-bricolage font-semibold text-base uppercase tracking-tight transition-colors duration-300"
      >
        {t('common.reload')}
      </button>
    </div>
  );
};

// A render error in one of the heavier widgets (3D viewer, flipbook, gallery)
// used to take the whole page down to a white screen. This keeps the rest of
// the page usable and offers a way out.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('ErrorBoundary caught an error:', error);
    }
  }

  render() {
    if (this.state.hasError) {
      return <Fallback onReload={() => window.location.reload()} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
